import React, { useEffect, useState } from "react";
import Sponsors from "../../pages/sponsors";
import { jsonRequest } from "../../api/noTokenRequest";
import { Loading } from "../../ui/loader";

const SponsorsContainer = () => {
  const [loading, setLoading] = useState(true);
  const [sponsors, setSponsors] = useState([]);

  useEffect(() => {
    jsonRequest("sponsors")
      .then((sponsors) => {
        setSponsors(sponsors);
        setLoading(false);
      })
      .catch((error) => {
        console.error('Error fetching sponsors:', error);
        setLoading(false);
      });
  }, []);

  if (loading) {
    return <Loading loading={ loading} />
  }

  return <Sponsors sponsors={sponsors} />;
};

export default SponsorsContainer;

